$(".languages").on({mouseenter: function () {
        $('.languages-popup').fadeIn(500);
    },
});

$(".languages-popup").on({mouseleave: function () {
        $('.languages-popup').fadeOut(500);
    },
});

//$(".site-header").on({mouseenter: function () {
        //if ($('.site-header').hasClass('header--transparent'))
        //{
            //$('.site-header').toggleClass('header--has-scrolled');
            //$('.site-header').toggleClass('header--top-reference');
            //$('.site-header').removeClass('header--transparent');
        //}
    //},
//});

//$(".site-header").on({mouseleave: function () {
        //if ($('.site-header').hasClass('header--top-reference'))
        //{
            //$('.site-header').removeClass('header--has-scrolled');
            //$('.site-header').removeClass('header--top-reference');
            //$('.site-header').toggleClass('header--transparent');
        //}
    //},
//});

jQuery(function ($) {
    $.fn.hScroll = function (amount) {
        amount = amount || 120;
        $(this).bind("DOMMouseScroll mousewheel", function (event) {
            var oEvent = event.originalEvent, 
                direction = oEvent.detail ? oEvent.detail * -amount : oEvent.wheelDelta, 
                position = $(this).scrollLeft();
            position += direction > 0 ? -amount : amount;
            $(this).scrollLeft(position);
            event.preventDefault();
        })
    };
});

function showImage2() {
  $('.image2').hide();
  $('.image2hover').show();
}

function hideImage2() {
  $('.image2').show();
  $('.image2hover').hide();
}

function showImage3() {
  $('.image3').hide();
  $('.image3hover').show();
}

function hideImage3() {
  $('.image3').show();
  $('.image3hover').hide();
}

function showImage4() {
  $('.image4').hide();
  $('.image4hover').show();
}

function hideImage4() {
  $('.image4').show();
  $('.image4hover').hide();
}

function showImage6() {
  $('.image6').hide();
  $('.image6hover').show();
}

function hideImage6() {
  $('.image6').show();
  $('.image6hover').hide();
}

function showImage7() {
  $('.image7').hide();
  $('.image7hover').show();
}

function hideImage7() {
  $('.image7').show();
  $('.image7hover').hide();
}

function showImage8() {
  $('.image8').hide();
  $('.image8hover').show();
}

function hideImage8() {
  $('.image8').show();
  $('.image8hover').hide();
}

$(document).ready(function() {
    $('#box').hScroll(60);
});

function showMadrid() {
  $('.madrid2').fadeIn(500)
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').toggleClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showCanarias() {
  $('.madrid2').hide();
  $('.canarias2').fadeIn(500);
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').toggleClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showGalicia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').fadeIn(500);
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').toggleClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showAndalucia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').fadeIn(500);
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').toggleClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showExtremadura() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').fadeIn(500);
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').toggleClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showCastillayLeon() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').fadeIn(500);
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').toggleClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showAragon() {
  $('.madrid2').hide()
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').fadeIn(500);
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').toggleClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showCantabria() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').fadeIn(500);
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').toggleClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showValencia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').fadeIn(500);
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').toggleClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showAndorra() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').fadeIn(500);
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').toggleClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showAsturias() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').fadeIn(500);
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').toggleClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showMallorca() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').fadeIn(500);
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').toggleClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showCastillalaMancha() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').fadeIn(500);
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').toggleClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showCataluna() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').fadeIn(500);
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').toggleClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showFrancia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').fadeIn(500);
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').toggleClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showIrlanda() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').fadeIn(500);
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').toggleClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showPaisesbajos() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').fadeIn(500);
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').toggleClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showPaisVasco() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').fadeIn(500);
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').toggleClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showPanama() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').fadeIn(500);
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').toggleClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showBelgica() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').fadeIn(500);
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').toggleClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showChile() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').fadeIn(500);
  $('.italia2').hide();
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').toggleClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showItalia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide();
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').fadeIn(500);
  $('.suecia2').hide();

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').toggleClass('storeselected');
  $('.suecia').removeClass('storeselected');
}

function showSuecia() {
  $('.madrid2').hide();
  $('.canarias2').hide();
  $('.galicia2').hide();
  $('.andalucia2').hide();
  $('.extremadura2').hide();
  $('.castillayleon2').hide();
  $('.aragon2').hide();
  $('.cantabria2').hide();
  $('.valencia2').hide();
  $('.andorra2').hide();
  $('.asturias2').hide();
  $('.mallorca2').hide();
  $('.castillalamancha2').hide();
  $('.cataluna2').hide();
  $('.francia2').hide();
  $('.irlanda2').hide();
  $('.paisvasco2').hide();
  $('.paisesbajos2').hide();
  $('.belgica2').hide;
  $('.panama2').hide();
  $('.chile2').hide();
  $('.italia2').hide();
  $('.suecia2').fadeIn(500);

  $('.madrid').removeClass('storeselected');
  $('.canarias').removeClass('storeselected');
  $('.galicia').removeClass('storeselected');
  $('.andalucia').removeClass('storeselected');
  $('.extremadura').removeClass('storeselected');
  $('.castillayleon').removeClass('storeselected');
  $('.aragon').removeClass('storeselected');
  $('.cantabria').removeClass('storeselected');
  $('.valencia').removeClass('storeselected');
  $('.andorra').removeClass('storeselected');
  $('.asturias').removeClass('storeselected');
  $('.mallorca').removeClass('storeselected');
  $('.castillalamancha').removeClass('storeselected');
  $('.cataluna').removeClass('storeselected');
  $('.francia').removeClass('storeselected');
  $('.irlanda').removeClass('storeselected');
  $('.paisvasco').removeClass('storeselected');
  $('.paisesbajos').removeClass('storeselected');
  $('.panama').removeClass('storeselected');
  $('.belgica').removeClass('storeselected');
  $('.chile').removeClass('storeselected');
  $('.italia').removeClass('storeselected');
  $('.suecia').toggleClass('storeselected');
}

function showHoverLookbook6() {
  $('.lookbook6-hover').fadeIn(500);
  $('.lookbook6-blank').hide();
}

function hideHoverLookbook6() {
  $('.lookbook6-hover').hide();
  $('.lookbook6-blank').show();
}

  $('.quickadd-variant').click(function(){   
    var product_id = $(this).data('variantid');

    gtag_report_conversion();

    data = {
      "id": product_id,
      "quantity": 1
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href='/cart';
      }
    });
});

function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-379911641/iYh5CI2LlZECENn7k7UB',
      'event_callback': callback
  });
  return false;
}

function gtag_report_conversion2(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-379911641/ZwupCKKHjMcDENn7k7UB',
      'event_callback': callback
  });
  return false;
}

function gtag_report_conversion3(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-379911641/rp18CPSGtJECENn7k7UB',
      'event_callback': callback
  });
  return false;
}

function gtag_report_conversion4(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-379911641/9dfiCL6MlZECENn7k7UB',
      'event_callback': callback
  });
  return false;
}
